// import _ from 'lodash'
import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: [],
  loaded: false,
}

// getters
const getters = {
  getAllPages: state => state.all,
  isPagesLoaded: state => state.loaded,
  getSingleContext: state => (slug) => {
    if(Object.prototype.hasOwnProperty.call(state.all, slug)) {
      if(Object.prototype.hasOwnProperty.call(state.all[slug], "items")) {
        if(state.all[slug]['items'] instanceof Array) {
          return state.all[slug]['items'][0]
        }
      }
      return state.all[slug]
    }
    return null
  }
}

// actions
const actions = {
  fetchPageByPath ({ commit }, { path, slug, lang }) {
    commit(types.PAGES_LOADED, false)
    api.fetchPageByPath(path, slug, lang, pages => {
      commit(types.STORE_FETCHED_PAGES, { pages })
      commit(types.PAGES_LOADED, true)
      // commit(types.INCREMENT_LOADING_PROGRESS)
    })
  },
  fetchPageByType ({ commit }, { type, slug, lang }) {
    commit(types.PAGES_LOADED, false)
    api.fetchPageByType(type, slug, lang, pages => {
      commit(types.STORE_FETCHED_PAGES, { pages })
      commit(types.PAGES_LOADED, true)
      // commit(types.INCREMENT_LOADING_PROGRESS)
    })
  },
}

// mutations
const mutations = {
  [types.STORE_FETCHED_PAGES] (state, { pages }) {
    state.all = { ...state.all, ...pages }
  },

  [types.PAGES_LOADED] (state, val) {
    state.loaded = val
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
